import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBfsRhy32bnEF__vYWnA602N6HiVB-MTio",
  authDomain: "ayushstock-f0050.firebaseapp.com",
  projectId: "ayushstock-f0050",
  storageBucket: "ayushstock-f0050.firebasestorage.app",
  messagingSenderId: "769426610758",
  appId: "1:769426610758:web:ce5d367fe790a4577a8847"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };

